import React from 'react';
import { toDateInputValue } from 'utils/date-time';
import WithDateRangeDataFetched from 'app/containers/WithDateRangeDataFetched';
import TwilioCallsTableByType from 'app/components/admin-statistics/TwilioCallsTableByType';
import TwilioCallsTableByRestaurant from 'app/components/admin-statistics/TwilioCallsTableByRestaurant';

interface ITwilioCallsByType {
  type: string;
  label: string;
  count: number;
}

interface ITwilioCallsByRestaurant {
  restaurant_id: number;
  restaurant_name: string;
  count: number;
}

interface ITwilioStats {
  by_type?: ITwilioCallsByType[];
  by_restaurant?: ITwilioCallsByRestaurant[];
}

const getUrl = (start: Date, end: Date) =>
  `/statistics/twilio-calls?from=${toDateInputValue(
    start
  )}&to=${toDateInputValue(end)}`;

const TwilioCallsStatistics = () => {
  return (
    <WithDateRangeDataFetched<ITwilioStats> allowRefetch getUrl={getUrl}>
      {(data) => {
        return (
          <div>
            <h3>Twilio Calls Statistics</h3>
            
            {data?.by_type && data.by_type.length > 0 && (
              <div style={{ marginBottom: '2rem' }}>
                <TwilioCallsTableByType data={data.by_type} />
              </div>
            )}
            
            {data?.by_restaurant && data.by_restaurant.length > 0 && (
              <div style={{ marginBottom: '2rem' }}>
                <TwilioCallsTableByRestaurant data={data.by_restaurant} />
              </div>
            )}
            
            {(!data?.by_type || data.by_type.length === 0) && 
             (!data?.by_restaurant || data.by_restaurant.length === 0) && (
              <div>No Twilio calls data available for the selected date range.</div>
            )}
          </div>
        );
      }}
    </WithDateRangeDataFetched>
  );
};

TwilioCallsStatistics.displayName = 'TwilioCallsStatistics';

export default TwilioCallsStatistics;
